import React, { useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FJActionTextBasedEditing from '../../../../../redux/action/textBasedEditing/FJActionTextBasedEditing.js';
import FJIconButton from '../../../../../common/components/FJIconButton/FJIconButton.jsx';
import DownloadIcon from '../../../../../assets/svg/download-black.svg?react';
import EditIcon from '../../../../../assets/svg/transcribe/edit.svg?react';
import HideIcon from '../../../../../assets/svg/transcribe/sub-hide.svg?react';
import startUrl from '../../../../../assets/base64/start-gradient.js';
import FJToolTip from '../../../../../common/components/FJToolTip/FJToolTip.jsx';
import FJDropdownNew from '../../../../../common/components/FJDropDown/FJDropdownNew.jsx';
import FJEditMenu from '../view/FJEditMenu.jsx';
import classNames from 'classnames';
import FJSearchMatchContainer from './FJSearchMatchContainer.jsx';
import styles from './FJToolContainer.module.less';
import FJActionTextBasedEditingExtension from '../../../../../redux/action/textBasedEditing/FJActionTextBasedEditingExtension.js';

const FJToolContainer = () => {
    const _dropdown = useRef();
    const dispatch = useDispatch();
    const isHideTextForDelete = useSelector(state => state.textBasedEditing.isHideTextForDelete);

    const _onShowOrHide = () => {
        dispatch(FJActionTextBasedEditingExtension.switchToDisplayTextOfDeleteAction());
    };

    const _downloadText = () => {
        dispatch(FJActionTextBasedEditingExtension.downloadTextAction());
    };

    const _hideMenu = useCallback(() => {
        if (_dropdown.current) _dropdown.current.hide();
    }, []);

    const _renderTrigger = config => {
        return (
            <FJToolTip title={'ai-edit'}>
                <div onClick={config.onClick} ref={config.ref} style={{ position: 'relative' }}>
                    <FJIconButton icon={<EditIcon />} className={classNames(styles.icon_button)} />
                    <img src={startUrl} className={styles.start_icon} />
                </div>
            </FJToolTip>
        );
    };

    const _renderOverlay = config => {
        return (
            <div ref={config.ref}>
                <FJEditMenu hideMenu={_hideMenu} />
            </div>
        );
    };

    return (
        <div className={styles.box}>
            <FJSearchMatchContainer />
            <div className={styles.right}>
                <FJDropdownNew
                    placement={'rightCenter'}
                    ref={_dropdown}
                    isTopLayer={true}
                    useAnchorBody
                    trigger='click'
                    renderTrigger={_renderTrigger}
                    renderOverlay={_renderOverlay}
                    offsetLeft={120}
                />

                <FJToolTip title={isHideTextForDelete ? 'show-deleted-text' : 'hide-deleted-text'}>
                    <div>
                        <FJIconButton
                            icon={<HideIcon />}
                            className={classNames(styles.icon_button, !isHideTextForDelete && styles.active)}
                            onClick={_onShowOrHide}
                        />
                    </div>
                </FJToolTip>

                <FJToolTip title={'download'}>
                    <div>
                        <FJIconButton icon={<DownloadIcon />} className={styles.icon_button} onClick={_downloadText} />
                    </div>
                </FJToolTip>
            </div>
        </div>
    );
};

export default FJToolContainer;
